export function ResolvedTickets({ active = false }: any) {
  const color = active ? "#006AB3" : "#84818A";
  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.2442 10.1382V13.6645C20.2442 16.75 18.4765 18.0724 15.8249 18.0724H6.98622C4.33462 18.0724 2.56689 16.75 2.56689 13.6645V7.49354C2.56689 4.40805 4.33462 3.08569 6.98622 3.08569H11.4055"
        stroke={color}
        stroke-width="1.58683"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.98633 7.93408L9.75283 10.138C10.6632 10.8609 12.1569 10.8609 13.0673 10.138"
        stroke={color}
        stroke-width="1.58683"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.017 2.48606L18.2644 2.98855C18.3882 3.23539 18.6975 3.4646 18.9715 3.5175L19.3074 3.57039C20.315 3.73789 20.5536 4.47841 19.8289 5.21011L19.5195 5.51865C19.3162 5.73023 19.2013 6.13575 19.2632 6.41786L19.3074 6.60299C19.5814 7.81956 18.9362 8.28678 17.8755 7.65205L17.6457 7.51982C17.3717 7.36114 16.9298 7.36114 16.6558 7.51982L16.426 7.65205C15.3565 8.29559 14.7113 7.81956 14.9941 6.60299L15.0383 6.41786C15.1002 6.13575 14.9853 5.73023 14.782 5.51865L14.4727 5.21011C13.7479 4.47841 13.9865 3.73789 14.9941 3.57039L15.33 3.5175C15.5952 3.47342 15.9133 3.23539 16.0371 2.98855L16.2846 2.48606C16.7619 1.52515 17.5397 1.52515 18.017 2.48606Z"
        stroke={color}
        stroke-width="1.58683"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
